import { render, staticRenderFns } from "./TeamsDetails.vue?vue&type=template&id=2cd20b64&scoped=true&"
import script from "./TeamsDetails.vue?vue&type=script&lang=ts&"
export * from "./TeamsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TeamsDetails.vue?vue&type=style&index=0&id=2cd20b64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd20b64",
  null
  
)

export default component.exports